import {pageService} from "../services/pages.services";

export const setPage = ( page ) => dispatch => {
    dispatch({
        type: "SET_PAGE",
        page
    });
}

export const getPage = (state) => dispatch => {
    dispatch({
        type: "GET_PAGE",
        state
    });
}

export const checkLogin = (data ) => dispatch => {

    let loggedInUser = pageService.loginUser(data);

    loggedInUser.then(loggedInUser => {
        dispatch({
            type: "USER_LOGGEDIN",
            loggedInUser
        });
    });
}
export const checkLogout = (data ) => dispatch => {

    dispatch({
        type: "USER_LOGGEDOUT"
    });

}


// WEBPACK FOOTER //
// ./src/actions/pages.js